import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NewsletterFormComponent } from '../../newsletter/newsletter-form.component';
export namespace NCmsNewsletter {
    export interface IComponentData extends NICmsContentComponent.IData {
        // source id
        source?: string;
        // custom success nessage
        successMessage?: string;
    }
}
@ICmsComponent<CmsNewsletterComponent>({
    id: 'newsletter',
    name: 'Inline newsletter form',
    description: 'Component is optimised to work with footer',
    image: '/common/cms/newsletter-component.png',
    isAdvanced: true,
    tags: ['newsletter', 'footer'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Success message'
        },
        {
            key: 'source',
            type: NICmsContentField.EFieldType.text,
            title: 'Source id for tracking'
        }
    ]
})
@Component({
    selector: 'cms-newsletter',
    templateUrl: './cms-newsletter.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NewsletterFormComponent]
})
export class CmsNewsletterComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsNewsletter.IComponentData;
}
